import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/card";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import OrgPayment from "@/atomic/organisms/orgPayment";

export default function RechargeCardView({
  isLoading,
  goBack,
  payment,
  activeCard,
  onChangeCard,
  creditCard,
  error,
  setError,
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="z-10 p-4 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="pb-[calc(120px)]">
            <h2 className="mt-6 text-black text-xl">Cartão de crédito</h2>
            <div className="w-full flex mt-4">
              {creditCard && <button
                type="button"
                className="relative flex flex-col w-[calc(152px)] max-w-[calc(49%)] items-start"
                onClick={() => onChangeCard(0)}
              >
                <img
                  src={"/creditCard.png"}
                  width={152}
                  alt="Card credit icon"
                  className="w-full"
                />
                <p className="text-sm ml-2 mt-[calc(-23px)] text-white">Final {creditCard?.slice(-4)}</p>
                {activeCard === 0 && <img
                  src={"/icon-checked.png"}
                  width={16}
                  height={16}
                  alt="Card credit icon"
                  className="absolute right-0 mt-[calc(-5px)] mr-[calc(-5px)]"
                />}
              </button>}
              <button
                type="button"
                className={`relative flex flex-col ${creditCard ? "ml-2" : ""} w-[calc(152px)] max-w-[calc(49%)] items-start`}
                onClick={() => onChangeCard(creditCard ? 1 : 0)}>
                <img
                  src={"/creditCard.png"}
                  width={152}
                  alt="Card credit icon"
                  className="w-full"
                />
                <p className="text-sm ml-2 mt-[calc(-23px)] text-white">Usar {creditCard ? "outro " : " "}cartão</p>
                {(activeCard === 1 || (activeCard === 0 && !creditCard)) && <img
                  src={"/icon-checked.png"}
                  width={16}
                  height={16}
                  alt="Card credit icon"
                  className="absolute right-0 mt-[calc(-5px)] mr-[calc(-5px)]"
                />}
              </button>
            </div>
          </div>
        
        </article>
        <OrgPayment 
            textLabel="Pagar"
            onClick={payment}
          />
      </main>
      {error && <Modal
        title="Ops!"
        message="Não foi possível fazer seu pagamento! Quer tentar novamente?"
        actionMessage="Sim"
        action={payment}
        actionSecondMessage="Não"
        actionSecond={() => setError(false)}
      />}
      {isLoading && <Loading />}
    </div>
  );
}
